import { render } from "./ContractsObjectsTab.vue?vue&type=template&id=052d1c9f&scoped=true"
import script from "./ContractsObjectsTab.vue?vue&type=script&lang=js"
export * from "./ContractsObjectsTab.vue?vue&type=script&lang=js"

import "./ContractsObjectsTab.vue?vue&type=style&index=0&id=052d1c9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052d1c9f"]])

export default __exports__